var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: {
        id: "verify-form",
        action: "#/registration/verify",
        method: "post",
      },
    },
    [
      _c("div", { staticClass: "form-page" }, [
        _c(
          "div",
          { staticClass: "container-main" },
          [
            _c(
              "b-row",
              { staticClass: "w-100 no-gutters bg justify-content-center" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "text-center",
                    attrs: { sm: "7", cols: "11" },
                  },
                  [
                    _c("h1", { staticClass: "main-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("account.verification.almostReady")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i18n", {
                      staticClass: "description",
                      attrs: {
                        path: "account.verification.sentEmailTo",
                        tag: "p",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "email",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "bold",
                                  attrs: { id: "showmail" },
                                },
                                [_vm._v(_vm._s(_vm.verificationEmail))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "w-100 justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "img-checked d-flex justify-content-center",
                    attrs: { cols: "5", sm: "4", lg: "2" },
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: require("@Shared/@Assets/img/app-flow/mail-img.svg"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "w-100 justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "text-center", attrs: { md: "6" } },
                  [
                    _c("p", { staticClass: "almost-description" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "account.verification.checkForVerificationCode"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "w-100 justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "text-center", attrs: { md: "4" } },
                  [
                    _c("div", {
                      staticClass: "my-3",
                      attrs: { id: "verification-alert" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "article",
              [
                _c(
                  "b-container",
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "half",
                            attrs: { sm: "4", cols: "8" },
                          },
                          [
                            _c("material-input", {
                              staticClass: "text-center",
                              attrs: {
                                label: _vm.$t("global.words.code"),
                                "class-name": "text-center",
                                disabled: _vm.loading,
                                "on-type": "",
                              },
                              model: {
                                value: _vm.confirmationCode,
                                callback: function ($$v) {
                                  _vm.confirmationCode = $$v
                                },
                                expression: "confirmationCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-container",
                  [
                    _c("b-row", [
                      _c(
                        "div",
                        { staticClass: "app-flow-buttons mt-4" },
                        [
                          _c(
                            "b-container",
                            [
                              _c(
                                "b-row",
                                { staticClass: "justify-content-center" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "forward",
                                      attrs: { sm: "5" },
                                    },
                                    [
                                      _c(
                                        "simple-button",
                                        {
                                          attrs: {
                                            disabled: _vm.$v.$invalid,
                                            "class-name":
                                              "py-2 px-5 rounded-pill",
                                            loading: _vm.loading,
                                            "loading-succeeded":
                                              _vm.loadingStatus,
                                          },
                                          on: { click: _vm.handleSubmit },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "account.verification.verifyAccount"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-center pt-2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "clickable text-primary font-sm",
                                          attrs: { id: "resend-code" },
                                          on: { click: _vm.handleResendCode },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "account.verification.resendCode"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }